import { Injectable } from '@angular/core';
import { FilesActions } from './models/action.model';
import { DownloadService } from './download.service';

@Injectable({
  providedIn: 'root',
})
export class FilesActionRuleService {
  readonly maxPreviewBytes = 20 * 1024 * 1024;
  readonly maxTotalBytes = 50 * 1024 * 1024 * 1024;

  constructor(private _downloadService: DownloadService) {}

  getSelectedFileCount(selectedNodes: any[] = []): number {
    if (!selectedNodes?.length) {
      return 0;
    }

    return selectedNodes.filter((node) => node.allChildrenCount === null).length;
  }

  getSelectedTotalSize(selectedNodes: any[] = []): number {
    if (!selectedNodes?.length) {
      return 0;
    }

    return selectedNodes
      .filter((node) => node.allChildrenCount === null && node.data?.size)
      .reduce((sum, node) => sum + node.data.size, 0);
  }

  canMove(accessControl: FilesActions, selectedNodes: any[] = []): boolean {
    return !!(accessControl.move && selectedNodes?.length > 0);
  }

  canCopy(accessControl: FilesActions, selectedNodes: any[] = []): boolean {
    return !!(
      accessControl.copy &&
      selectedNodes?.length > 0 &&
      selectedNodes.filter((node) => node?.data?.formUpload).length === 0
    );
  }

  canDownload(accessControl: FilesActions, selectedNodes: any[] = []): boolean {
    return !!(
      accessControl.download &&
      selectedNodes?.length > 0 &&
      this.getSelectedTotalSize(selectedNodes) <= this.maxTotalBytes
    );
  }

  canDelete(accessControl: FilesActions, selectedNodes: any[] = []): boolean {
    return !!(
      accessControl.delete &&
      selectedNodes?.length > 0 &&
      selectedNodes.filter((node) => !node?.data?.allowDelete).length === 0 &&
      selectedNodes.filter((node) => node?.data?.formUpload).length === 0
    );
  }

  canTagAdd(accessControl: FilesActions, highlightedNodes: any[] = []): boolean {
    return !!(accessControl.tag && highlightedNodes?.length > 0);
  }

  canTagDelete(accessControl: FilesActions, highlightedNodes: any[] = []): boolean {
    return !!(accessControl.tag && highlightedNodes?.length === 1);
  }

  canAssociationAdd(accessControl: FilesActions, highlightedNodes: any[] = []): boolean {
    return !!(accessControl.tag && highlightedNodes?.length > 0);
  }

  canAssociationDelete(
    accessControl: FilesActions,
    highlightedNodes: any[] = [],
    selectedNodes: any[] = []
  ): boolean {
    return !!(
      accessControl.tag &&
      highlightedNodes?.length === 1 &&
      selectedNodes.filter((node) => !node?.data?.allowDelete).length === 0 &&
      selectedNodes.filter((node) => node?.data?.formUpload).length === 0
    );
  }

  canEditName(accessControl: FilesActions, highlightedNodes: any[] = [], selectedNodes: any[] = []): boolean {
    return !!(
      accessControl.editName &&
      highlightedNodes?.length === 1 &&
      selectedNodes.filter((node) => !node?.data?.allowRename).length === 0 &&
      selectedNodes.filter((node) => node?.data?.formUpload).length === 0
    );
  }

  canPreview(accessControl: FilesActions, highlightedNodes: any[] = []): boolean {
    return !!(
      accessControl.preview &&
      highlightedNodes?.length === 1 &&
      highlightedNodes[0]?.data?.documentKey?.docType === 'FILE' &&
      highlightedNodes[0]?.data?.size < this.maxPreviewBytes &&
      this._downloadService.previewableExtensions.includes(
        this._downloadService.getFileType(highlightedNodes[0].data.path)
      )
    );
  }
}
